<script setup lang="ts">
import Button from '@components/Button.vue';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';

defineProps<{ icon?: string, iconName?: string }>();
</script>

<template>
  <Button class="menu-item">
    <Icon
      v-if="icon"
      :svg="icon"
      :custom-class="iconName"
      height="24"
      width="24"
    />

    <Typography variant="body">
      <slot />
    </Typography>
  </Button>
</template>
